import mpx from '@mpxjs/core'
import { getErrorMessage } from '../../../utils/error'
import {
  getOrderDetail,
  setPageShareConfig,
  updateOrder,
  cancelOrder,
} from '../../../biz'
import {
  EnumGoodsDetailIsSpike,
  EnumOrderDetailType,
  EnumOrderDetailPayStatus,
  EnumOrderOperateType,
  EnumOrderCloseType,
} from '../../../defines'
import { GlobalEnv, initEnv, login } from '../../../global_env'
import { URLQueries } from '../../../global_env/url_query'
import { runAsyncHooks, runHooks } from '../page_detail/utils'
import { setTitle } from '../../../index'
import { mpSubscribe } from '@/lib/js/mp_subscribe'
import { query, build } from '@didi/webx-js'
import { ORDER_ERR_STATUS } from '@/lib/webx/biz/order'
import { TechPageErrorCancelOrderFail } from '@/lib/webx/tech_error_track'
import { MASErrorTrackCancelOrderError } from '@/lib/webx/mas_error_track'
import { dealPageErrno } from '@/lib/webx/api'

const DefaultPageConfig = {
  hooks: {},
}

const render = function (goods, hooks) {
  const MallRenderData = {
    template: 'normal',
    components: [
      {
        name: 'top-header',
        data: {
          // TODO: 把这块 买一赠一 的内容回头解耦一下
          hideTitle: goods?.goodsExtra?.hideTitle,
          title: goods.goodsName,
          isBogo: goods.isSpike === EnumGoodsDetailIsSpike.Bogo,
          couponLeft: goods.couponLeft,
          couponNumber: goods.couponNumber,
          privilegeNumber: goods.privilegeNumber,
          privilegeLeft: goods.privilegeLeft,
          couponUsed: goods.couponUsed || 0,
          bogoSaveMoney: goods.shareCouponOrderInfo.saveMoney,
          shareLimit: goods.shareCouponOrderInfo.shareLimit,
          shareNum: goods.shareCouponOrderInfo.shareNum,
          currentTime: goods.currentTime,
          disableTime: goods.disableTime,
          bogoRole: goods.shareCouponOrderInfo.role,
          // pay_status 1 说明已支付未退款
          isExpired:
            goods.payStatus === EnumOrderDetailPayStatus.Paid &&
            goods.currentTime > goods.disableTime,
          currency: goods.currency,
          price: goods.cashAmount,
          payStatus: goods.payStatus,
          goods,
          productType: goods.productType,
          cardShow: goods.cardShow,
        },
      },
      {
        name: 'coupon-packages-list',
        data: {
          list: goods.package || [],
          currency: goods.currency,
          productType: goods.productType,
        },
        style: {
          'margin-top': 0,
        },
      },
      {
        name: 'guideline-list',
        data: {
          customPicList: goods?.goodsExtra?.customPic,
        },
      },
      {
        name: 'order-info',
        data: {
          orderId: goods.id,
          payTime: goods.payTime,
          disableTime: goods.disableTime,
          cashBackTime: goods.cashbackTime,
          goodsType: goods.goodsType,
          isExpired:
            goods.payStatus === EnumOrderDetailPayStatus.Paid &&
            goods.currentTime > goods.disableTime,
          payStatus: goods.payStatus,
          goodsId: goods.goodsId,
        },
      },
      {
        name: 'usable-scope',
        data: {
          goods,
        },
      },
      {
        name: 'guideline',
        data: {
          extraPic: goods.goodsExtra?.extraPic,
        },
      },
      goods?.isSpike === 7 && goods?.productType === '258'
        ? {}
        : {
            name: 'rules',
            data: {
              goodsDesc: goods.goodsDesc,
            },
          },
      {
        name: 'city-info',
        data: {
          cityDesc: goods.cityDesc,
        },
      },
      {
        name: 'supplementar',
        data: {
          goodsExtraDesc: goods?.goodsExtraDesc,
        },
      },
      {
        name: 'order-operation',
        data: {
          orderId: goods.id,
          payTime: goods.payTime,
          disableTime: goods.disableTime,
          goodsType: goods.goodsType,
          isExpired:
            goods.payStatus === EnumOrderDetailPayStatus.Paid &&
            goods.currentTime > goods.disableTime,
          payStatus: goods.payStatus,
          goodsId: goods.goodsId,
          productType: goods.productType,
          help: goods?.help,
        },
      },
    ],
  }
  // 如果是线路价
  if (goods.isSpike === EnumGoodsDetailIsSpike.Route && goods.routeType) {
    MallRenderData.components.splice(2, 0, {
      name: 'route-box',
      data: {
        disbleChange: true,
        routeType: goods.routeType,
        productType: goods.productType,
        goodsId: goods.goodsId,
        startRoute: {
          name: goods.startingName,
          lat: goods.startingLat,
          lng: goods.startingLng,
        },
        endRoute: {
          name: goods.destName,
          lat: goods.destLat,
          lng: goods.destLng,
        },
      },
    })
  }
  const res = runHooks.call(this, hooks.beforeRender, MallRenderData, goods)
  return res || MallRenderData
}

export const PageOrderDetailMixin = PageConfig => {
  const config = {
    ...DefaultPageConfig,
    ...PageConfig,
  }

  return {
    async onLoad() {
      await initEnv({
        needLocation: true,
        beforeInitPlantFormFn: () => {
          setTitle(PageConfig.title || this.$t('orderDetail.title'))
        },
      })
      // setTitle(PageConfig.title || this.$t('orderDetail.title'))
      if (!GlobalEnv.isLogin) {
        await login()
      }
      try {
        await runAsyncHooks.call(this, config.hooks.beforeDetail)
        // 前者是各种活动接口调了之后，从接口获取的
        const orderId = this.$_orderId || URLQueries.getQuery('id')
        const couponId = URLQueries.getQuery('cardId')
        const data = await getOrderDetail(orderId || couponId, {
          type: orderId
            ? EnumOrderDetailType.Order
            : EnumOrderDetailType.Coupon,
        })
        const orderDetail = data.info.orderData
        // 后端apollo控制，目前仅支持主小发推送
        // 其他小程序如果需要支持订阅，需要找pm去申请对应小程序中的模版id给到后端去开发，然后在微信平台中间页配置活动id为taocan_xcxtz的配置
        if (data.isPush) {
          // 小程序推送实验，通过 is_push 分流
          mpSubscribe()
        }
        await runAsyncHooks.call(this, config.hooks.afterDetail, orderDetail)
        const canBogoSend =
          orderDetail.isSpike === EnumGoodsDetailIsSpike.Bogo &&
          orderDetail.shareCouponOrderInfo.shareCode &&
          orderDetail.shareCouponOrderInfo.shareLimit -
            orderDetail.shareCouponOrderInfo.shareNum >
            0
        setPageShareConfig({
          pathname: canBogoSend ? 'orderDetail' : 'goodsDetail',
          isDetail: true,
          addGoodsId: !canBogoSend,
          goodsId: orderDetail.goodsId,
          shareConfigRequestParams: {
            goodsId: orderDetail.goodsId,
          },
          // TODO: 解耦这个逻辑。。。
          extraQueries: canBogoSend
            ? {
                bogo_share_code: orderDetail.shareCouponOrderInfo.shareCode,
                bogo_order_id: orderDetail.id,
              }
            : {},
        })
          .then(config => (this.$_shareConfig = config))
          .catch(() => {})
        this.orderDetail = orderDetail
        this.MallRenderData = render.call(this, orderDetail, config.hooks)
      } catch (error) {
        // AsyncHookBlocker是展示买赠异常的弹窗，此时无需进入异常页面
        if (error.message !== 'AsyncHookBlock') {
          this.pageErrno = dealPageErrno(error)
        }
      }
    },
    data: {
      MallRenderData: {
        template: '',
        components: [],
      },
      pageErrno: 0,
      orderDetail: {},
      continuePayPending: false,
      cancelOrderPending: false,
    },
    methods: {
      $_onMallPageEvent(params) {
        const { method, args } = params.detail
        if (typeof this[method] === 'function') {
          this[method](...args)
        }
      },
      reload() {
        window.location.reload()
      },
      async deleteOrder() {
        try {
          const res = await mpx.showModal({
            title: this.$t('orderDetail.deleteConfirmTitle'),
            content: this.$t('orderDetail.deleteConfirmContent'),
            showCancel: true,
            cancelText: this.$t('orderDetail.deleteConfirmCancelBtn'),
            confirmText: this.$t('orderDetail.deleteConfirmConfirmBtn'),
            confirmColor: '#DA0000',
          })
          if (res.confirm) {
            try {
              mpx.showLoading()
              await updateOrder(this.orderDetail.id, {
                type: EnumOrderOperateType.Delete,
              })
              mpx.hideLoading()
              mpx.showToast({
                title: this.$t('orderDetail.deleteTheOrderComplete'),
                icon: 'none',
                duration: 800,
              })
              setTimeout(() => {
                const href = window.location.href
                window.history.back()
                setTimeout(() => {
                  if (window.location.href === href) {
                    const queries = {
                      ...query(),
                    }
                    delete queries.id
                    delete queries.bogo_share_code
                    const url =
                      build('./index.html', queries) +
                      '#/personal?active=purchase-history'
                    window.location.replace(url)
                  }
                }, 400)
              }, 800)
            } catch (error) {
              mpx.hideLoading()
              mpx.showModal({
                content: getErrorMessage(error),
                showCancel: false,
              })
            }
          }
        } catch (error) {}
      },
      /**
       * 取消订单
       */
      goCancelOrder(options = {}) {
        if (this.cancelOrderPending) {
          return
        }
        this.cancelOrderPending = true
        const params = {
          order_id: this.orderDetail.id,
          partition_id: this.orderDetail.partition_id,
          close_type: options?.closeType || EnumOrderCloseType.Cancel, // 8 取消， 5超时
        }
        cancelOrder(params)
          .then(res => {
            if (typeof options.successCb === 'function') {
              options.successCb.call(this, res)
            }
          })
          .catch(err => {
            TechPageErrorCancelOrderFail({
              id: this.orderDetail.id,
            })
            MASErrorTrackCancelOrderError('取消订单失败', {
              id: this.orderDetail.id,
            })
            if (typeof options.failCb === 'function') {
              options.failCb.call(this, err)
            }
            return Promise.reject()
          })
          .finally(() => {
            this.cancelOrderPending = false
          })
      },
      /**
       * 继续支付
       */
      goContinueOrder() {
        this.continueOrderFlow({
          orderDetail: this.orderDetail,
          payResExtra: {
            rechargePhone: this.orderDetail.rechargePhone,
          },
          hooks: {
            dealResErrEdFunc(res) {
              // 订单已关闭的情况下刷新页面
              const { errno } = res
              if ([ORDER_ERR_STATUS.OrderClosed].indexOf(errno) === -1) {
                return
              }
              setTimeout(() => {
                window.location.reload()
              }, 1000)
            },
          },
          noSuccessUrl: true, // 不需要收银台跳转
          mini_back: true, // 使用webx-js 的监听订单状态
        })
      },
    },
  }
}
